{
  "aiBundleRemovalNotice": {
    "title": "Your AI profiles bundle will be cancelled too - it can be kept only with Edit plan"
  },
  "cancelPlanList": {
    "cancellingBadge": "Cancelling",
    "summary": {
      "title": "You Pay",
      "keepPrefix": "You'll keep ",
      "keepAllNote": "Keep all {0} products",
      "cancelAllNote": "You're cancelling your whole plan",
      "currentLabel": "Current",
      "afterLabel": "After cancellation",
      "endsNote": "Subscription ends",
      "renewNote": "Your credits will be adjusted in next renew cycle"
    },
    "rows": {
      "AFTERSHOOT_CULLING": { "label": "Select" },
      "AFTERSHOOT_EDITING": { "label": "Edit" },
      "AFTERSHOOT_RETOUCHING": { "label": "Retouch" }
    }
  }
}
